import React from "react";
import { useTranslation } from "react-i18next";
import { CalendarCheck, CalendarClock, CalendarX, CalendarSearch } from "lucide-react";
import { inviteChipInfo } from "./inviteStatus";

// Respuesta del lead a la invitación de Google Calendar de la demo (la crea y la lee
// v_demoGoogleInvite; aquí solo se pinta). Sin invitación no pinta nada.
const STYLE = {
  accepted: { Icon: CalendarCheck, cls: "bg-green-50 text-green-700 border-green-200" },
  pending: { Icon: CalendarClock, cls: "bg-gray-50 text-gray-600 border-gray-200" },
  declined: { Icon: CalendarX, cls: "bg-red-50 text-red-700 border-red-200" },
  tentative: { Icon: CalendarSearch, cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

export default function InviteChip({ demo, size = "xs" }) {
  const { t } = useTranslation("misAgendas");
  const info = inviteChipInfo(demo);
  if (!info) return null;
  const { Icon, cls } = STYLE[info.key];
  const base = info.email ? t("invite.title", { email: info.email }) : t("invite.titleNoEmail");
  const when = info.answeredAt
    ? t("invite.answeredAt", {
        date: new Date(info.answeredAt).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }),
      })
    : "";
  const title = when ? `${base} · ${when}` : base;
  const sz = size === "sm" ? "text-xs px-2 py-0.5" : "text-[11px] px-1.5 py-0.5";
  return (
    <span title={title} data-testid="invite-chip" className={`inline-flex items-center gap-1 rounded-full border font-semibold whitespace-nowrap ${sz} ${cls}`}>
      <Icon size={11} aria-hidden="true" /> {t("invite.label")}: {t(`invite.${info.key}`)}
    </span>
  );
}
